import React, { useEffect, useRef, useState } from "react";
import { customer, customerEdit, getBrancheslist } from '../utils/api';
import { Link,useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";
import axios from "axios";

const AddCustomerLayer = () => {

  
   const [nameErr, setNameErr] = useState(false);
      const [emailErr, setEmailErr] = useState(false);
      const [passwordErr, setPasswordErr] = useState(false);
      const [phoneErr, setPhoneErr] = useState(false);
      const [branchErr, setBranchErr] = useState(false);
      const [branchList, setBranchList] = useState({});
  
   const [formData, setFormData] = useState({
      name: '',
      phone:'',
      email: '',
      password: '',
      branch_name:''
    });
    const navigate = useNavigate();
    let { id } = useParams();
  
console.log('id', id);

    async function fetchCustomerInfo() {
      axios
        .get(process.env.REACT_APP_API_BASE_URL+"customer-details/" + id)
        .then((res) => {
          // return false;
          if (res.data) {
            console.log("red data", res.data);
             
            setFormData({ ...formData, name: res.data.name, phone: res.data.phone, email: res.data.email, password: res.data.password, branch_name: res.data.branch_name });
                     
          } else {
            toast.success("something went wrong...");
          }
        })
        .catch((err) => {
          console.error(err);
          alert(err);
        });
    }

    useEffect(() => {
      if(id){ 
       fetchCustomerInfo();
        } else{
         setFormData({ ...formData, name: "", phone: "", email: "", password: "", branch_name: "" });
         
        }
     }, [id]);
    useEffect(() => {
      let branchesList = getBrancheslist();
      setBranchList(branchesList);
    }, []);
    
 

    const handleSubmit = async (e) => {
      e.preventDefault();
     
      try {
         if(formData?.name &&  formData?.email &&  formData?.phone &&  formData?.password &&  formData?.branch_name){
                  if(id){
                    await customerEdit(id,formData);
                  }else{
                    await  customer(formData);
                  }
           toast.success('Customer details successfully saved');
        navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/customer');
                } else{
                  if(!formData?.name){
                    setNameErr(true);
                   }
                  if(!formData?.email){
                    setEmailErr(true);
                   }
                 if(!formData?.phone){
                  setPhoneErr(true);
                    }
                  if(!formData?.password){
                    setPasswordErr(true);
                      }
                  if(!formData?.branch_name){
                      setBranchErr(true);
                     }
                }
      } catch (error) {
        toast.error('Something went wrong: ' + error.message);
      }
    };

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>{(id)?"Edit":"Add New "} Customer</h6>
          </div>
          <div className='card-body p-24'>
            <ToastContainer></ToastContainer>
            <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>
              <div className="row">
              <div  className='col-lg-6'>
                <label className='form-label fw-bold text-neutral-900'
                htmlFor="branch_name">
                  Branch Name:{" "}
                </label>
                <select onChange={(e) =>{
                   setFormData({ ...formData, branch_name: e.target.value });
                    setBranchErr(false);
                   if(e.target.value == 0){
                    setBranchErr(true);
                   }
                   }} 
                 id="branch_name"   name="branch_name"    value={formData.branch_name}   className={branchErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
              >
                   {branchList.length >0 && branchList.map((branchval, key)=>(<option value={key}>{branchval}</option>))}
                 </select>
                {branchErr && (
                        <span className="error-message">
                            {'Branch name is mandatory'}
                        </span>
                    )} 
              </div>
              
                  <div className='col-lg-6'>
                    <label
                      className='form-label fw-bold text-neutral-900'
                      htmlFor='title'
                    >
                       Name:{" "}
                    </label>
                    <input
                      type='text'
                      className={nameErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                      id='name'
                      name='name'
                      placeholder='Enter Name'
                      value={formData.name}
                      onChange={(e) =>{
                        setFormData({ ...formData, name: e.target.value });
                        setNameErr(false);
                        if(e.target.value.trim() == ""){
                          setNameErr(true);
                        }
                     }}                    />
                        {nameErr && (
                        <span className="error-message">
                            {'Name is mandatory'}
                        </span>
                    )} 
                  </div>

                  <div className='col-lg-6'>
                    <label
                      className='form-label fw-bold text-neutral-900'
                      htmlFor='title'
                    >
                      Phone:{" "}
                    </label>
                    <input
                      type='text'
                      className={phoneErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                      id='phone'
                      placeholder='Enter Phone'
                      name="phone"
                      value={formData.phone}
                      onChange={(e) =>{
                        setFormData({ ...formData, phone: e.target.value.trim() });
                        setPhoneErr(false);
                        if(e.target.value.trim() == ""){
                          setPhoneErr(true);
                        }
                     }}                    />
                       {phoneErr && (
                        <span className="error-message">
                            {'Phone No is mandatory'}
                        </span>
                    )} 
                  </div>
               
                  
                  <div className='col-lg-6'>
                    <label
                      className='form-label fw-bold text-neutral-900'
                      htmlFor='title'
                    >
                      Email:{" "}
                    </label>
                    <input
                      type='text'
                      className={emailErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                      id='email'
                      placeholder='Enter Email'
                      autoComplete="off"
                      name="email"
                      value={formData.email}
                      onChange={(e) =>{
                        setFormData({ ...formData, email: e.target.value.trim() });
                        setEmailErr(false);
                        if(e.target.value.trim() == ""){
                          setEmailErr(true);
                        }
                     }} />
                       {emailErr && (
                        <span className="error-message">
                            {'Email ID is mandatory'}
                        </span>
                    )} 
                  </div>
                  {(!id)?<div className='col-lg-6'>
                    <label
                      className='form-label fw-bold text-neutral-900'
                      htmlFor='title'
                    >
                       Password:{" "}
                    </label>
                    <input
                      type='password'
                      className={passwordErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                      id='password'
                      name='password'
                      autoComplete="off"
                      placeholder='Enter Password'
                      value={formData.password}
                      onChange={(e) =>{
                        setFormData({ ...formData, password: e.target.value.trim() });
                        setPasswordErr(false);
                        if(e.target.value.trim() == ""){
                          setPasswordErr(true);
                        }
                     }}                    />
                       {passwordErr && (
                        <span className="error-message">
                            {'Password is mandatory'}
                        </span>
                    )}
                  </div>:""}
                  <div className='col-lg-6 pt-3'>
                  <button type='submit' className='btn btn-primary-600 mt-3 radius-8'>
                Submit
              </button>
              </div>
              </div>
             
            </form>
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddCustomerLayer;
